const initialState = {
  leanplumStart: false,
};

const trackerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LEANPLUM_START":
      return {
        ...state,
        leanplumStart: true,
      };
    default:
      return state;
  }
};

export default trackerReducer;
